import { LangContext } from "@natklok/contexts/langContext";
import { useContext } from "react";

const useTranslatePageText = (): ((key: string) => string) => {
  const { translatePageText } = useContext(LangContext);
  return translatePageText;
};

export default useTranslatePageText;
